import React, { useEffect, useState, useContext } from 'react';
import { default as t } from '../../../utils/i18n';
import { Button } from '../../atoms';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { EmailTooltip, SearchBar, Dropdown } from '../../atoms/index';
import './reports-container.scss';
import { DashService } from '../../../services';
import { UserContext } from '../../../context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import ClientReportTable from '../client-report-table/client-report-table';
import { createPostTrackUsagePayload, UsageIdentifierFlow } from '../../../utils/misc';
import { postTrackUsageAPI } from '../../../services/dash.service';

function ReportsContainer() {
  const automatedReportType = 'submitted';
  const draftReportType = 'draft';
  const { user, setUser } = useContext(UserContext);
  const filterOption = [
    ['campaign_name', 'campaign_id', 'objective', 'kpi'],
    ['campaign_name'],
    ['campaign_id'],
    ['objective'],
    ['kpi'],
  ];

  const options = [
    { value: 'reportId,type,campaignName,reportName,status', label: t('reportTable.text.all') },
    { value: 'reportId', label: t('reports.container.report.id') },
    { value: 'type', label: t('reports.container.report.type') },
    { value: 'reportName', label: t('reports.container.report.name') },
    { value: 'campaignName', label: t('reports.container.campaign.name') },
    { value: 'status', label: t('reports.container.status') },
  ];

  const [selectedAdverse, setSelectedAdverse] = useState('');
  const [selectedAdAccount, setSelectedAdAccount] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [filterBy, setFilterBy] = useState(options[0]);
  const [advertisersList, setAdvertisersList] = useState([]);
  const [adAccounts, setAdAccounts] = useState([]);
  const [tabValue, setTabValue] = useState('1');
  const [liveCount, setLiveCount] = React.useState(0);
  const [completedCount, setCompletedCount] = React.useState(0);
  const [dropdownFilterby, setDropdownFilterby] = useState(options[0]?.value);
  const history = useHistory();

  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;

  const handleOnSelectAdverse = selectedOption => {
    setSelectedAdAccount('');
    setLiveCount(0);
    setCompletedCount(0);
    setSelectedAdverse(selectedOption);
    getAdAccounts(selectedOption, false);
    clearSearch();
  };

  useEffect(() => {
    if (selectedAdAccount) {
      const adAccountId = [selectedAdAccount.value];

      const localStorageUserObj = localStorage.getItem('user');
      const { usageAPIPayload, updatedLocalStorageUserValue } = createPostTrackUsagePayload(
        adAccountId,
        JSON.parse(localStorageUserObj),
        UsageIdentifierFlow.AD_ACCOUNT
      );

      if (usageAPIPayload.ids.length) {
        postTrackUsageAPI(userAccessToken, username, {
          ...usageAPIPayload,
          userFlow: `reports`,
        });
      }
      localStorage.setItem('user', JSON.stringify(updatedLocalStorageUserValue));
      setUser(updatedLocalStorageUserValue);
    }
  }, [selectedAdAccount]);

  const handleOnSelectAdAccount = async selectedOption => {
    setSelectedAdAccount(selectedOption);
    clearSearch();
  };

  const handleSearchOnChange = searchText => {
    setSearchKeyword(searchText);
  };
  const handleDropdownOnChange = dropdwnVal => {
    setFilterBy(dropdwnVal);
    setDropdownFilterby(dropdwnVal.value);
  };

  const getAllAdvertiser = async () => {
    try {
      const response = await DashService.advertiserList(userAccessToken, username);
      let adverseList = response.data?.data?.map(advertiser => ({
        value: advertiser,
        label: advertiser,
      }));
      if (user?.selectedAdvertiser) {
        let index = adverseList?.findIndex(li => li?.value === user?.selectedAdvertiser);
        if (index > -1) {
          setSelectedAdverse(adverseList[index]);
          getAdAccounts(adverseList[index], false);
        }
      }
      setAdvertisersList(adverseList);
    } catch (error) {}
  };

  async function getAdAccounts(selectedOption, selectFromContext = true) {
    try {
      const adAcResponse = await DashService.getAdAccountsForAdvertisers(
        userAccessToken,
        username,
        selectedOption.value
      );
      let adAccountList = adAcResponse.data?.data?.map(adAccounts => ({
        value: adAccounts.id,
        label: adAccounts.name,
      }));
      if (user?.selectedAdaccounts) {
        let adIndex = adAccountList?.findIndex(li => li?.value === user?.selectedAdaccounts);
        if (adIndex > -1) {
          setSelectedAdAccount(adAccountList[adIndex]);
        }
      }
      setAdAccounts(adAccountList);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  const handleChange = (event, newValue) => {
    setUser(() => ({
      ...user,
      isSaveDraft: false,
    }));
    setTabValue(Number(newValue));
  };
  const updateCount = (count, type) => {
    if (type === automatedReportType) {
      setLiveCount(count);
    } else {
      setCompletedCount(count);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllAdvertiser();
    setUser(() => ({
      ...user,
      activeStep: 0,
      draftReportId: '',
      reportName: '',
      isFirstTimeCreation: false,
    }));
    if (user?.isSaveDraft) {
      setTabValue(2);
    }
  }, []);

  const onImportClick = async e => {
    e.preventDefault();
    setUser(() => ({
      ...user,
      activeStep: 0,
      draftReportId: '',
      reportName: '',
      isSaveDraft: false,
      isSubmitted: false,
    }));
    try {
      history.push('/define-report');
    } catch (error) {
      //console.log(error);
    }
  };

  const clearSearch = () => {
    setSearchKeyword('');
    setFilterBy(options[0]);
    setDropdownFilterby(options[0].value);
    setTabValue('1');
  };

  return (
    <section className={`report-container`}>
      <div className="header-container">
        <div>
          <h2>{t('report.table.client.reporting')}</h2>
          <p>{t('report.table.campaign.improvement')}</p>
        </div>
      </div>
      <div className="import-campaign-cta-report">
        <Button
          type="button"
          label={t('report.table.create.report')}
          handleClick={onImportClick}
        ></Button>
        <i className="eva eva-arrow-circle-right icon-forward"></i>
      </div>
      <div className="listing-container optimisation">
        <div className="filter-section">
          <div className="left-section">
            <div style={{ width: '230px', height: '67px' }}>
              <Dropdown
                className="user-select"
                heading={t('reportTable.text.advertiser')}
                value={selectedAdverse}
                options={advertisersList}
                onSelect={handleOnSelectAdverse}
                placeholder={t('create.report.share.modal.placeholder3')}
                tooltipIndicator={true}
                tooltipId={t('business-manager')}
                infoData={t('report.container.tooltip.advertiser')}
              />
            </div>
            <div className="ad-account" style={{ width: '306px', height: '67px' }}>
              <Dropdown
                heading={t('define.stepper.adAccount')}
                value={selectedAdAccount}
                options={adAccounts}
                onSelect={handleOnSelectAdAccount}
                placeholder={t('define.stepper.adAccount.placeholder')}
                tooltipIndicator={true}
                searchIndicator={true}
                tooltipId={t('ad-account')}
                infoData={t('report.container.tooltip.adAccount')}
                search={true}
              />
            </div>
          </div>
          <div>
            <SearchBar
              onChange={handleSearchOnChange}
              value={searchKeyword}
              onDropdownChange={handleDropdownOnChange}
              options={options}
              filterBy={filterBy}
              placeholder={t('report.table.search.report')}
            />
          </div>
        </div>
        <div>
          <h3>{t('report.table.reports.heading')}</h3>
        </div>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabValue.toString()}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label={t('insights.report.list.heading')}>
                <Tab
                  label={
                    <React.Fragment>
                      <span className="text">{t('report.table.automated')} </span>
                      <span>({liveCount})</span>
                      <EmailTooltip
                        id={t('automated-reports')}
                        emailToolTip={t('report.container.tooltip.automated')}
                      />
                    </React.Fragment>
                  }
                  value="1"
                />
                <Tab
                  label={
                    <React.Fragment>
                      <span className="text">{t('report.table.drafts')} </span>
                      <span>({completedCount})</span>
                      <EmailTooltip
                        id={t('draft-reports')}
                        emailToolTip={t('report.container.tooltip.draft')}
                      />
                    </React.Fragment>
                  }
                  value="2"
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              {selectedAdAccount && (
                <ClientReportTable
                  selectedAdAccount={selectedAdAccount}
                  selectedAdverse={selectedAdverse}
                  reportType={automatedReportType}
                  updateCount={updateCount}
                  searchKeyword={searchKeyword}
                  filterBy={filterOption[dropdownFilterby]}
                  dropdownFilterby={dropdownFilterby}
                />
              )}
            </TabPanel>
            <TabPanel value="2">
              {selectedAdAccount && (
                <ClientReportTable
                  selectedAdAccount={selectedAdAccount}
                  selectedAdverse={selectedAdverse}
                  reportType={draftReportType}
                  updateCount={updateCount}
                  searchKeyword={searchKeyword}
                  filterBy={filterOption[dropdownFilterby]}
                  dropdownFilterby={dropdownFilterby}
                />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </section>
  );
}

export default ReportsContainer;
